import { useState } from "react";
import { supabase } from "@/lib/supabase";
import { useAdminResources, useAdminRows, fmtDateTime } from "@/lib/booking";
import { Card, Field, Select, SaveBtn, Ok, Err, SubTitle, useAction, smallBtn, inputCls } from "./adminUI";

const KINDS = [["jetski", "Jet ski"], ["lancha", "Lancha"], ["escuna", "Escuna"], ["drone", "Drone"], ["outro", "Outro"]];
const STATES = [["operational", "Operacional"], ["maintenance", "Em manutenção"], ["inactive", "Inativo"]];
const iso = (v) => new Date(v).toISOString();

function Maintenance({ resource, periods, run, busy }) {
    const [m, setM] = useState({ starts_at: "", ends_at: "", reason: "" });
    return (
        <div className="mt-3 space-y-2">
            <div className="flex flex-wrap gap-2">
                <input type="datetime-local" className={inputCls + " mt-0 w-auto"} value={m.starts_at} onChange={(e) => setM({ ...m, starts_at: e.target.value })} />
                <input type="datetime-local" className={inputCls + " mt-0 w-auto"} value={m.ends_at} onChange={(e) => setM({ ...m, ends_at: e.target.value })} />
                <input placeholder="Motivo" className={inputCls + " mt-0 w-40"} value={m.reason} onChange={(e) => setM({ ...m, reason: e.target.value })} />
                <button className={smallBtn} disabled={busy || !m.starts_at || !m.ends_at}
                    onClick={() => run(() => supabase.from("resource_maintenance").insert({ resource_id: resource.id, reason: m.reason, starts_at: iso(m.starts_at), ends_at: iso(m.ends_at) }))}>+ Manutenção</button>
            </div>
            {periods.map((p) => (
                <p key={p.id} className="flex items-center gap-3 text-xs text-dim">{fmtDateTime(p.starts_at)} → {fmtDateTime(p.ends_at)} {p.reason}
                    <button className="text-neon-coral" onClick={() => run(() => supabase.from("resource_maintenance").delete().eq("id", p.id))}>remover</button></p>
            ))}
        </div>
    );
}

export default function ResourcesAdmin() {
    const resources = useAdminResources();
    const maint = useAdminRows("maintenance", (sb) => sb.from("resource_maintenance").select("*").gte("ends_at", new Date().toISOString()).order("starts_at"));
    const [f, setF] = useState({ name: "", identifier: "", kind: "jetski", capacity: 2 });
    const { run, busy, msg, err } = useAction();
    const set = (k) => (v) => setF((o) => ({ ...o, [k]: v }));

    return (
        <Card className="space-y-4">
            <SubTitle>Equipamentos e embarcações</SubTitle>
            <div className="grid gap-4 sm:grid-cols-4" data-testid="resources-admin">
                <Field label="Nome" value={f.name} onChange={set("name")} testid="resource-name" />
                <Field label="Identificador (ex.: inscrição)" value={f.identifier} onChange={set("identifier")} />
                <Select label="Tipo" value={f.kind} onChange={set("kind")} options={KINDS} />
                <Field label="Capacidade (pessoas)" type="number" value={f.capacity} onChange={set("capacity")} />
            </div>
            <div className="flex items-center justify-end gap-3"><Ok msg={msg} /><Err msg={err} />
                <SaveBtn saving={busy} testid="resource-create" onClick={() => run(() => supabase.from("resources").insert({ ...f, capacity: Number(f.capacity) || 1 }))}>Cadastrar</SaveBtn></div>
            {(resources.data || []).map((r) => (
                <div key={r.id} className="border-t border-ink/10 pt-3" data-testid={`resource-row-${r.id}`}>
                    <div className="flex flex-wrap items-center justify-between gap-3 text-sm">
                        <span><strong>{r.name}</strong> {r.identifier && `· ${r.identifier}`} · {KINDS.find((k) => k[0] === r.kind)?.[1]} · {r.capacity} pessoa(s)</span>
                        <div className="flex gap-2">
                            <select className={inputCls + " mt-0 w-auto"} value={r.status} onChange={(e) => run(() => supabase.from("resources").update({ status: e.target.value }).eq("id", r.id))}>
                                {STATES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select>
                            <button className={smallBtn} onClick={() => window.confirm("Excluir equipamento?") && run(() => supabase.from("resources").delete().eq("id", r.id))}>Excluir</button>
                        </div>
                    </div>
                    <Maintenance resource={r} periods={(maint.data || []).filter((m) => m.resource_id === r.id)} run={run} busy={busy} />
                </div>
            ))}
        </Card>
    );
}
